import {Space, SpaceProps} from 'antd';
import {omit} from 'lodash';
import {FC} from 'react';

export interface SCSpaceProps extends SpaceProps {
    block?: boolean;
    justify?: 'space-evenly' | 'space-between' | 'space-around' | 'start' | 'end' | 'center';
}

const FLEX_MAP: any = {
    'end': 'flex-end',
    'start': 'flex-start',
};

export const SCSpace: FC<SCSpaceProps> = props => {

    const spaceProps = omit(props, ['block', 'justify']);
    const justify = props?.justify ? (FLEX_MAP[props?.justify] || props?.justify) : 'flex-start';

    return (
        <Space
            style={{
                width: props?.block ? '100%' : 'auto',
                justifyContent: justify,
            }}
            {...spaceProps}
        >
            {props?.children}
        </Space>
    );
};
